/* eslint-disable import/no-cycle */
import {
  getPermitPrices,
  getSearchRequestPrices,
  getHistoricalPrices,
  getOperationalPrices,
  getProductPrice,
  getProductTypes,
  getChargeBys,
  postProductPrice,
  getJobEventLogs,
  getMiscellaneousPrices,
} from "./services/product-price-api";

export const SET_PERMIT_PRICES = "productPrices/SET_PERMIT_PRICES";
export const SET_SEARCH_REQUEST_PRICES = "productPrices/SET_SEARCH_REQUEST_PRICES";
export const SET_HISTORICAL_PRICES = "productPrices/SET_HISTORICAL_PRICES";
export const SET_OPERATIONAL_PRICES = "productPrices/SET_OPERATIONAL_PRICES";
export const SET_PRODUCT_PRICE = "productPrices/SET_PRODUCT_PRICE";
export const SET_PRODUCT_TYPES = "productPrices/SET_PRODUCT_TYPES";
export const SET_CHARGEBY_OPTIONS = "productPrices/SET_CHARGEBY_OPTIONS";
export const FETCH_PERMIT_PRICES = "productPrices/FETCH_PERMIT_PRICES";
export const FETCH_SEARCH_REQUEST_PRICES = "productPrices/FETCH_SEARCH_REQUEST_PRICES";
export const FETCH_HISTORICAL_PRICES = "productPrices/FETCH_HISTORICAL_PRICES";
export const FETCH_OPERATIONAL_PRICES = "productPrices/FETCH_OPERATIONAL_PRICES";
export const FETCH_PRODUCT_TYPES = "productPrices/FETCH_PRODUCT_TYPES";
export const UPDATE_PRODUCT_PRICE = "productPrices/UPDATE_PRODUCT_PRICE";
export const FETCH_PRODUCT_PRICE = "productPrices/FETCH_PRODUCT_PRICE";
export const FETCH_CHARGEBY_OPTIONS = "productPrices/FETCH_CHARGEBY_OPTIONS";
export const POST_PRODUCT_PRICE = "productPrices/POST_PRODUCT_PRICE";
export const FETCH_JOB_EVENT_LOGS = 'productPrices/FETCH_JOB_EVENT_LOGS';
export const SET_JOB_EVENT_LOGS = 'productPrices/SET_JOB_EVENT_LOGS';
export const FETCH_MISCELLANEOUS_PRICES = "productPrices/FETCH_MISCELLANEOUS_PRICES";
export const SET_MISCELLANEOUS_PRICES = "productPrices/SET_MISCELLANEOUS_PRICES";

export const productPricesStore = {
  state: {
    permitPrices: null,
    searchrequestPrices: null,
    historicalPrices: null,
    operationalPrices: null,
    currentPrice: null,
    productTypes: null,
    chargeByOptions: null,
    jobEventLogs: null,
    miscellaneousPrices: null,
  },
  mutations: {
    [SET_PERMIT_PRICES](state, { prices }) {
      state.permitPrices = prices;
    },
    [SET_SEARCH_REQUEST_PRICES](state, { prices }) {
      state.searchrequestPrices = prices;
    },
    [SET_HISTORICAL_PRICES](state, { prices }) {
      state.historicalPrices = prices;
    },
    [SET_OPERATIONAL_PRICES](state, { prices }) {
      state.operationalPrices = prices;
    },
    [SET_PRODUCT_PRICE](state, { price }) {
      state.currentPrice = price;
    },
    [SET_PRODUCT_TYPES](state, { products }) {
      state.productTypes = products;
    },

    [SET_CHARGEBY_OPTIONS](state, { chargebys }) {
      state.chargeByOptions = chargebys;
    },
    [SET_JOB_EVENT_LOGS](state, { jobEventLogs }) {
      state.jobEventLogs = jobEventLogs;
    },
    [SET_MISCELLANEOUS_PRICES](state, { prices }) {
      state.miscellaneousPrices = prices;
    },
  },
  getters: {
    permitPrices: (state) => state.permitPrices,
    searchrequestPrices: (state) => state.searchrequestPrices,
    historicalPrices: (state) => state.historicalPrices,
    operationalPrices: (state) => state.operationalPrices,
    currentPrice: (state) => state.currentPrice,
    productTypes: (state) => state.productTypes,
    chargeByOptions: (state) => state.chargeByOptions,
    jobEventLogs: (state) => state.jobEventLogs,
    miscellaneousPrices: (state) => state.miscellaneousPrices,
  },
  actions: {
    [FETCH_PERMIT_PRICES]: async ({ commit }) => {
      console.log(1);
      commit(SET_PERMIT_PRICES, { prices: null });
      const resp = await getPermitPrices();

      /// ////flattening prices entities
      let result = [];
      resp.data.forEach((product) => {
        if (product == null || product.prices == null) return result;

        if (product.prices && product.prices.length > 0) {
          const temp = product.prices.map((x) => {
            let localEffective = false;
            if (x.effectiveStartDate != null && x.effectiveStartDate !== "null") {
              const d1 = new Date(x.effectiveStartDate);
              const currentDate = new Date();
              if (currentDate > d1) localEffective = true;
            }
            return {
              productId: product.productId,
              productCode: product.productCode,
              productName: product.productName,
              productType: product.productType,
              productDescription: product.productDescription,
              beenEffective: localEffective,
              price: x,
            };
          });
          result = [...result, ...temp];
        }
        return null;
      });

      commit(SET_PERMIT_PRICES, { prices: result });
    },
    [FETCH_SEARCH_REQUEST_PRICES]: async ({ commit }) => {
      commit(SET_SEARCH_REQUEST_PRICES, { prices: null });
      const resp = await getSearchRequestPrices();

      /// ////flattening prices entities
      let result = [];
      resp.data.forEach((product) => {
        if (product == null || product.prices == null) return result;

        if (product.prices && product.prices.length > 0) {
          const temp = product.prices.map((x) => {
            let levyLabel = "";
            let localEffective = false;
            if (x.effectiveStartDate != null && x.effectiveStartDate !== "null") {
              const d1 = new Date(x.effectiveStartDate);
              const currentDate = new Date();
              if (currentDate > d1) localEffective = true;
            }
            if (x.levyFeeType === "$") {
              levyLabel = `$${x.amountLevy}`;
            }
            if (x.levyFeeType === "%") {
              levyLabel = `${x.amountLevy}%`;
            }

            if (x.levyFeeType !== "$" && x.levyFeeType !== "%") {
              levyLabel = x.amountLevy;
            }

            return {
              productId: product.productId,
              productCode: product.productCode,
              productName: product.productName,
              productType: product.productType,
              productDescription: product.productDescription,
              beenEffective: localEffective,
              amountLevy2: levyLabel,
              price: x,
            };
          });
          result = [...result, ...temp];
        }
        return null;
      });

      commit(SET_SEARCH_REQUEST_PRICES, { prices: result });
    },
    [FETCH_HISTORICAL_PRICES]: async ({ commit }) => {
      commit(SET_HISTORICAL_PRICES, { prices: null });
      const resp = await getHistoricalPrices();
      /// ////flattening pricechangelogs entities-ToDo
      let result = [];
      resp.data.forEach((product) => {
        if (product == null || product.priceChangeLogs == null) return result;

        if (product.priceChangeLogs && product.priceChangeLogs.length > 0) {
          const temp = product.priceChangeLogs.map((x) => ({
            productId: product.productId,
            productCode: product.productCode,
            productName: product.productName,
            productType: product.productType,
            productDescription: product.productDescription,
            pricechangeLog: x,
          }));
          result = [...result, ...temp];
        }
        return null;
      });
      commit(SET_HISTORICAL_PRICES, { prices: result });
    },

    [FETCH_OPERATIONAL_PRICES]: async ({ commit }) => {
      commit(SET_OPERATIONAL_PRICES, { prices: null });
      const resp = await getOperationalPrices();
      /// ////building up hiearchy
      const result = [];
      resp.data.forEach((product) => {
        const row = {};
        row.registrationID = product.registrationID;

        const fees = [];
        const fee1 = {
          opYear: new Date(product.toDate).getFullYear(),
          label: "1 month",
          value: product.fee1Month,
          registrationID: product.registrationID,
          registrationDesc: product.registrationDesc,
          levy: product.feeSCC,
        };
        fees.push(fee1);
        const fee2 = {
          opYear: new Date(product.toDate).getFullYear(),
          label: "2 month",
          value: product.fee2Month,
          registrationID: product.registrationID,
          registrationDesc: product.registrationDesc,
          levy: product.feeSCC,
        };
        fees.push(fee2);
        const fee3 = {
          opYear: new Date(product.toDate).getFullYear(),
          label: "3 month",
          value: product.fee3Month,
          registrationID: product.registrationID,
          registrationDesc: product.registrationDesc,
          levy: product.feeSCC,
        };
        fees.push(fee3);
        const fee4 = {
          opYear: new Date(product.toDate).getFullYear(),
          label: "4 month",
          value: product.fee4Month,
          registrationID: product.registrationID,
          registrationDesc: product.registrationDesc,
          levy: product.feeSCC,
        };
        fees.push(fee4);
        const fee5 = {
          opYear: new Date(product.toDate).getFullYear(),
          label: "5 month",
          value: product.fee5Month,
          registrationID: product.registrationID,
          registrationDesc: product.registrationDesc,
          levy: product.feeSCC,
        };
        fees.push(fee5);
        const fee6 = {
          opYear: new Date(product.toDate).getFullYear(),
          label: "6 month",
          value: product.fee6Month,
          registrationID: product.registrationID,
          registrationDesc: product.registrationDesc,
          levy: product.feeSCC,
        };
        fees.push(fee6);
        const fee7 = {
          opYear: new Date(product.toDate).getFullYear(),
          label: "7 month",
          value: product.fee7Month,
          registrationID: product.registrationID,
          registrationDesc: product.registrationDesc,
          levy: product.feeSCC,
        };
        fees.push(fee7);
        const fee8 = {
          opYear: new Date(product.toDate).getFullYear(),
          label: "8 month",
          value: product.fee8Month,
          registrationID: product.registrationID,
          registrationDesc: product.registrationDesc,
          levy: product.feeSCC,
        };
        fees.push(fee8);
        const fee9 = {
          opYear: new Date(product.toDate).getFullYear(),
          label: "9 month",
          value: product.fee9Month,
          registrationID: product.registrationID,
          registrationDesc: product.registrationDesc,
          levy: product.feeSCC,
        };
        fees.push(fee9);
        const fee10 = {
          opYear: new Date(product.toDate).getFullYear(),
          label: "10 month",
          value: product.fee10Month,
          registrationID: product.registrationID,
          registrationDesc: product.registrationDesc,
          levy: product.feeSCC,
        };
        fees.push(fee10);
        const fee11 = {
          opYear: new Date(product.toDate).getFullYear(),
          label: "11 month",
          value: product.fee11Month,
          registrationID: product.registrationID,
          registrationDesc: product.registrationDesc,
          levy: product.feeSCC,
        };
        fees.push(fee11);
        const fee12 = {
          opYear: new Date(product.toDate).getFullYear(),
          label: "12 month",
          value: product.fee12Month,
          registrationID: product.registrationID,
          registrationDesc: product.registrationDesc,
          levy: product.feeSCC,
        };
        fees.push(fee12);

        row.fees = fees;

        result.push(row);
        // return null;
      });
      commit(SET_OPERATIONAL_PRICES, { prices: result });
    },
    [POST_PRODUCT_PRICE]: async (_, payload) => {
      try {
        const { data } = payload;
        // console.log('update-data:', data);
        await postProductPrice(data);
      } catch (error) {
        console.error(`post_price_err:${error.Status}`);
        throw error;
      }
    },
    [FETCH_PRODUCT_PRICE]: async ({ commit }, payload) => {
      try {
        const { priceId } = payload;
        const resp = await getProductPrice(priceId);
        commit(SET_PRODUCT_PRICE, { price: resp.data.prices[0] });
      } catch (error) {
        console.error(`update price_err:${error.Status}`);
        throw error;
      }
    },

    [FETCH_PRODUCT_TYPES]: async ({ commit }) => {
      commit(SET_PRODUCT_TYPES, { products: null });
      const resp = await getProductTypes();
      commit(SET_PRODUCT_TYPES, { products: resp.data });
    },

    [FETCH_CHARGEBY_OPTIONS]: async ({ commit }) => {
      commit(SET_CHARGEBY_OPTIONS, { chargebys: null });
      const resp = await getChargeBys();
      commit(SET_CHARGEBY_OPTIONS, { chargebys: resp.data });
    },

    [FETCH_JOB_EVENT_LOGS]: async ({ commit }, payload) => {
      try {
        const { jobCode } = payload;
        return await getJobEventLogs(jobCode)
          .then((resp) => {
            commit(SET_JOB_EVENT_LOGS, { jobEventLogs: resp.data });
          })
          .catch((error) => {
            commit(SET_JOB_EVENT_LOGS, { jobEventLogs: null });
            console.error(`get-event-log_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_JOB_EVENT_LOGS, { jobEventLogs: null });
        console.error(`getno-event-log_err:${error.Status}`);
        throw error;
      }
    },
    [FETCH_MISCELLANEOUS_PRICES]: async ({ commit }) => {
      // console.log(1);
      commit(SET_MISCELLANEOUS_PRICES, { prices: null });
      const resp = await getMiscellaneousPrices();
      /// ////flattening price entities-ToDo
      let result = [];
      resp.data.forEach((product) => {
        if (product == null || product.prices == null) return result;

        if (product.prices && product.prices.length > 0) {
          const temp = product.prices.map((x) => {
            let localEffective = false;
            let amountLabel = "";
            if (x.effectiveStartDate != null && x.effectiveStartDate !== "null") {
              const d1 = new Date(x.effectiveStartDate);
              const currentDate = new Date();
              if (currentDate > d1) localEffective = true;
            }

            if (x.chargeBy === "Percentage") {
              amountLabel = `${x.amountApp}%`;
            }
            if (x.chargeBy !== "Percentage") {
              amountLabel = `$${x.amountApp}`;
            }
            return {
              productId: product.productId,
              productCode: product.productCode,
              productName: product.productName,
              productType: product.productType,
              productDescription: product.productDescription,
              beenEffective: localEffective,
              price: x,
              amountLabel2: amountLabel,
            };
          });
          result = [...result, ...temp];
        }
        return null;
      });

      commit(SET_MISCELLANEOUS_PRICES, { prices: result });
    },
  },
};
